<template>
  <div v-if="list.length" :class="['aside-post__tags', className]">
    <div v-if="title.length" class="aside-post__title t1">{{ title }}</div>
    <div class="aside-post__scroll-x">
      <div class="aside-post__tags-list">
        <Tag
          v-for="(item, index) in list"
          :key="index"
          :variant="'-secondary'"
          :href="path.length ? path + item : null"
          >{{ item }}</Tag
        >
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed, useI18n } from '#imports';
  import { Tag } from '@nuxt-shared/ui/tag';
  const { t } = useI18n({ useScope: 'local' });

  const title = computed(() => t('a_side_title_tags'));

  // props
  const { className, list } = defineProps({
    className: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: () => [],
    },
    path: {
      type: String,
      default: '',
    },
  });
</script>

<style scoped lang="scss">
  .aside-post {
    &__tags-list {
      display: flex;
      flex-wrap: wrap;
      gap: 16px 8px;

      @include until($lg) {
        padding-right: 64px;
        padding-left: 64px;
      }

      @include until($md) {
        flex-wrap: initial;
        width: min-content;
        padding-right: 24px;
        padding-left: 24px;
      }
    }
  }
</style>

<i18n lang="json">
{
  "ru": {
    "a_side_title_tags": "Теги"
  }
}
</i18n>
